function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import classNames from 'classnames';
import React from 'react';
import styles from './FormControls.module.scss';
const FormControlErrorWrapper = React.forwardRef(({
  invalid,
  className,
  ...props
}, ref) => React.createElement("div", _extends({
  ref: ref
}, props, {
  className: classNames(className, styles.formControlErrorWrapper, invalid && styles.invalid)
})));
export default FormControlErrorWrapper;